import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";

// Lets the fixed bottom-right buttons (IA widget, scroll top, edit article)
// move up so they don't sit under the DsimConnect bubble.
const BODY_CLASS = "has-dsim-widget";

// Same distance from the edges as our own fixed buttons.
const OFFSET = "24";

// The loader has no destroy API: it appends a button and, on first click, an
// iframe to <body>, so they are removed by hand.
const removeWidgetNodes = (origin: string) => {
  document
    .querySelectorAll(`iframe[src^="${origin}/"], button[aria-label$="chat de atendimento"]`)
    .forEach((node) => node.remove());
};

export default function DsimConnectWidget() {
  const { userLogged } = useAuth();
  const widget = userLogged?.dsim_widget;
  const isHome = useLocation().pathname === "/";

  useEffect(() => {
    if (!isHome || !widget?.url || !widget?.key) return;

    const origin = new URL(widget.url).origin;
    let disposed = false;

    const script = document.createElement("script");
    script.src = widget.url;
    script.async = true;
    script.dataset.key = widget.key;
    script.dataset.idExternal = widget.id_external;
    script.dataset.name = widget.name;
    if (widget.hash) script.dataset.hash = widget.hash;
    script.dataset.offsetX = OFFSET;
    script.dataset.offsetY = OFFSET;

    // A script removed while still downloading runs anyway once it arrives.
    script.addEventListener("load", () => {
      if (disposed) removeWidgetNodes(origin);
    });

    document.body.appendChild(script);
    document.body.classList.add(BODY_CLASS);

    return () => {
      disposed = true;
      script.remove();
      removeWidgetNodes(origin);
      document.body.classList.remove(BODY_CLASS);
    };
  }, [isHome, widget?.url, widget?.key, widget?.id_external, widget?.name, widget?.hash]);

  return null;
}
